import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import SidenavContentNavGroup from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup'
import { SidenavContentNavGroupDivider } from 'src/components/SidenavContentNavGroup/SidenavContentNavGroup.style'
import SidenavContentNavItem from 'src/components/SidenavContentNavItem/SidenavContentNavItem'
import { BudgetRequestStatus } from 'src/models/budgetRequest.models'
import { useMainNavItems } from 'src/navigation/sidenav/useMainNavItems'
import { getBudgetRequests } from 'src/redux/actions/data/budgetRequests.actions'
import { selectAllStatisticsLoadedFromState } from 'src/redux/selectors/app.selectors'

export interface SidenavMainContentProps {
  isSidenavOpen: boolean
}

const SidenavMainContent: React.FC<SidenavMainContentProps> = (
  props,
): React.ReactElement => {
  const dispatch = useDispatch()
  const { analytics } = useAnalyticsContext()

  const statisticsLoaded = useSelector(selectAllStatisticsLoadedFromState)

  const { navGroups } = useMainNavItems({
    isSidenavOpen: props.isSidenavOpen,
    onNotificationClick: (): void => {
      analytics?.track('home - view notification list - button press', {
        screen: '/home',
        interaction: 'button press',
        intent: 'view notification list',
      })
    },
    onActivityClick: (): void => {
      analytics?.track('home - view activity page - button press', {
        screen: '/home',
        interaction: 'button press',
        intent: 'view activity page',
      })
    },
  })

  // TODO: migrate to react-query
  useEffect((): void => {
    dispatch(
      getBudgetRequests({
        count: 1,
        page: 0,
        requester: 'me',
        statuses: [BudgetRequestStatus.Pending],
      }),
    )
  }, [])

  return (
    <>
      {statisticsLoaded.creditCardsActiveCanIssueVirtualCardsCountStatisticsLoaded &&
        statisticsLoaded.creditCardsUserOrViewerMeCountStatisticsLoaded &&
        statisticsLoaded.creditCardsSourceCountStatisticsLoaded &&
        navGroups.map((group, groupIndex) => {
          if (!group.condition) return null

          return (
            <React.Fragment key={groupIndex}>
              {group.showDivider && <SidenavContentNavGroupDivider />}
              <SidenavContentNavGroup isSidenavOpen={props.isSidenavOpen}>
                {group.items.map((item) => (
                  <SidenavContentNavItem
                    key={item.id}
                    isSidenavOpen={props.isSidenavOpen}
                    id={item.id}
                    isActive={item.isActive}
                    to={item.to}
                    onClick={item.onClick}
                    ActiveSvg={item.activeSvg}
                    InactiveSvg={item.inactiveSvg}
                    label={item.label}
                    expandOptions={item.expandOptions}
                    notificationsCount={item.notificationsCount}
                  />
                ))}
              </SidenavContentNavGroup>
            </React.Fragment>
          )
        })}
    </>
  )
}

export default SidenavMainContent
